import { render, staticRenderFns } from "./BadWords.vue?vue&type=template&id=42d45526&scoped=true"
import script from "./BadWords.vue?vue&type=script&lang=js"
export * from "./BadWords.vue?vue&type=script&lang=js"
import style0 from "./BadWords.vue?vue&type=style&index=0&id=42d45526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d45526",
  null
  
)

export default component.exports